import { AdminEditBillingRateComponent } from './admin-edit-billing-rate/admin-edit-billing-rate.component';
import { UserActivityIndexComponent } from './admin-user-activity/user-activity-index/user-activity-index.component';
import { FactEditComponent } from './facts/fact-edit/fact-edit.component';
import { FactIndexComponent } from './facts/fact-index/fact-index.component';
import { FactNewComponent } from './facts/fact-new/fact-new.component';
import { FactShowComponent } from './facts/fact-show/fact-show.component';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { authInterceptorProviders } from './../_helpers/auth.interceptor';
import { GuardianModule } from './../guardian/guardian.module';
import { MathModule } from './../math/math.module';
import { QuizModule } from './../quiz/quiz.module';
import { SharedModule } from './../shared/shared.module';
import { AdminAccountsComponent } from './admin-accounts/admin-accounts.component';
import { ActivityTypeIndexComponent } from './admin-activity-type/activity-type-index/activity-type-index.component';
import { ActivityTypeNewComponent } from './admin-activity-type/activity-type-new/activity-type-new.component';
import { AdminAgentComponent } from './admin-agent/admin-agent.component';
import { AnswerTemplateCreateComponent } from './admin-answer-templates/answer-template-create/answer-template-create.component';
import { AnswerTemplateEditComponent } from './admin-answer-templates/answer-template-edit/answer-template-edit.component';
import { AnswerTemplateIndexComponent } from './admin-answer-templates/answer-template-index/answer-template-index.component';
import { AnswerTemplateRenameComponent } from './admin-answer-templates/answer-template-rename/answer-template-rename.component';
import { AnswerTemplateShowComponent } from './admin-answer-templates/answer-template-show/answer-template-show.component';
import { AdminAwardedComponent } from './admin-awarded/admin-awarded.component';
import { AdminBadgedComponent } from './admin-badged/admin-badged.component';
import { AdminBillingChartComponent } from './admin-billing-chart/admin-billing-chart.component';
import { IndexCountryComponent } from './admin-countries/index-country/index-country.component';
import { NewCountryComponent } from './admin-countries/new-country/new-country.component';
import { ShowCountryComponent } from './admin-countries/show-country/show-country.component';
import { AdminDataComponent } from './admin-data/admin-data.component';
import { AdminDeviceSyncComponent } from './admin-devicesync/admin-devicesync.component';
import { AdminEnrollmentsComponent } from './admin-enrolments/admin-enrolments.component';
import { AdminGuardiansComponent } from './admin-guardians/admin-guardians.component';
import { AdminHistoryComponent } from './admin-history/admin-history.component';
import { AdminHomeShowComponent } from './admin-home-show/admin-home-show.component';
import { AdminInvoicesComponent } from './admin-invoices/admin-invoices.component';
import { EditLevelComponent } from './admin-levels/edit-level/edit-level.component';
import { IndexLevelComponent } from './admin-levels/index-level/index-level.component';
import { ListLevelTemplateComponent } from './admin-levels/list-level-template/list-level-template.component';
import { ShowLevelComponent } from './admin-levels/show-level/show-level.component';
import { AdminQuizEnvelopsComponent } from './admin-quiz-envelops/admin-quiz-envelops.component';
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { AdminShowQuestionDetailComponent } from './admin-show-question-detail/admin-show-question-detail.component';
import { AdminShowQuestionComponent } from './admin-show-question/admin-show-question.component';
import { AdminShowQuizComponent } from './admin-show-quiz/admin-show-quiz.component';
import { AdminStudentsComponent } from './admin-students/admin-students.component';
import { AdminConceptIndexComponent } from './admin-study/admin-concept-index/admin-concept-index.component';
import { AdminConceptNewComponent } from './admin-study/admin-concept-new/admin-concept-new.component';
import { AdminConceptShowComponent } from './admin-study/admin-concept-show/admin-concept-show.component';
import { AdminSubjectIndexComponent } from './admin-subjects/admin-subject-index/admin-subject-index.component';
import { AdminSyllabusAddTopicComponent } from './admin-syllabus/admin-syllabus-add-topic/admin-syllabus-add-topic.component';
import { AdminSyllabusIndexComponent } from './admin-syllabus/admin-syllabus-index/admin-syllabus-index.component';
import { AddSolutionComponent } from './admin-task-template/add-solution/add-solution.component';
import { QuestionTemplateEditComponent } from './admin-task-template/question-template-edit/question-template-edit.component';
import { QuestionTemplateIndexComponent } from './admin-task-template/question-template-index/question-template-index.component';
import { QuestionTemplateQuestionsComponent } from './admin-task-template/question-template-questions/question-template-questions.component';
import { QuestionTemplateRenameComponent } from './admin-task-template/question-template-rename/question-template-rename.component';
import { QuestionTemplateShowComponent } from './admin-task-template/question-template-show/question-template-show.component';
import { ReplaceTemplateComponent } from './admin-task-template/replace-template/replace-template.component';
import { TaskTemplateCreateComponent } from './admin-task-template/task-template-create/task-template-create.component';
import { UserLastActivityIndexComponent } from './admin-user-activity/user-last-activity-index/user-last-activity-index.component';
import { AdminUsersComponent } from './adminAuth/admin-users/admin-users.component';
import { AdminSyllabusNewComponent } from './syllabus/admin-syllabus-new/admin-syllabus-new.component';
import { AdminSyllabusSubtopicAddConceptComponent } from './syllabus/admin-syllabus-subtopic/admin-syllabus-subtopic-addconcept/admin-syllabus-subtopic-addconcept.component';
import { AdminSyllabusSubtopicAddTemplateComponent } from './syllabus/admin-syllabus-subtopic/admin-syllabus-subtopic-addtemplate/admin-syllabus-subtopic-addtemplate.component';
import { AdminSyllabusSubtopicEditComponent } from './syllabus/admin-syllabus-subtopic/admin-syllabus-subtopic-edit/admin-syllabus-subtopic-edit.component';
import { AdminSyllabusSubtopicShowComponent } from './syllabus/admin-syllabus-subtopic/admin-syllabus-subtopic-show/admin-syllabus-subtopic-show.component';
import { SearchSubTopicComponent } from './syllabus/admin-syllabus-subtopic/search-sub-topic/search-sub-topic.component';
import { AdminSyllabusAddSubtopicComponent } from './syllabus/admin-syllabus-topic/admin-syllabus-add-subtopic/admin-syllabus-add-subtopic.component';
import { AdminSyllabusTopicEditComponent } from './syllabus/admin-syllabus-topic/admin-syllabus-topic-edit/admin-syllabus-topic-edit.component';
import { AdminSyllabusTopicShowComponent } from './syllabus/admin-syllabus-topic/admin-syllabus-topic-show/admin-syllabus-topic-show.component';


import { DeviceSyncDetailComponent } from './device-sync-detail/device-sync-detail.component';
import { FactSubTopicIndexComponent } from './facts/fact-sub-topic-index/fact-sub-topic-index.component';
import { ManageStudentComponent } from './manage-student/manage-student.component';
import { MoveStudentComponent } from './move-student/move-student.component';
import { ProgressEmailListComponent } from './progress-email-list/progress-email-list.component';
import { TestImageComponent } from './test-image/test-image.component';

import { AbilityEditComponent } from './ability-edit/ability-edit.component';
import { AbilityIndexComponent } from './ability-index/ability-index.component';
import { AbilityShowComponent } from './ability-show/ability-show.component';
import { AdminFreeWorksheetComponent } from './admin-free-worksheet/admin-free-worksheet.component';
import { TaskDescriptionTopologyMultipartComponent } from './admin-task-template/task-description-topology-multipart/task-description-topology-multipart.component';
import { TaskDescriptionTopologyOneComponent } from './admin-task-template/task-description-topology-one/task-description-topology-one.component';
import { TaskDescriptionComponent } from './admin-task-template/task-description/task-description.component';
import { TaskPartModalComponent } from './admin-task-template/task-part-modal/task-part-modal.component';
import { TaskTemplateAbilityComponent } from './admin-task-template/task-template-ability/task-template-ability.component';
import { TaskTemplateCreateVariantComponent } from './admin-task-template/task-template-create-variant/task-template-create-variant.component';
import { TaskTemplateLoadComponent } from './admin-task-template/task-template-load/task-template-load.component';
import { TaskVariantPartModalComponent } from './admin-task-template/task-variant-part-modal/task-variant-part-modal.component';
import { ViewSampleDetailComponent } from './admin-task-template/view-sample-detail/view-sample-detail.component';
import { ViewTaskSampleComponent } from './admin-task-template/view-task-sample/view-task-sample.component';
import { BoldEmitterComponent } from './bold-emitter/bold-emitter.component';
import { ListEducationSystemComponent } from './educationSystem/list-education-system/list-education-system.component';
import { NewEducationSystemComponent } from './educationSystem/new-education-system/new-education-system.component';
import { ExamFormatIndexComponent } from './exam/exam-format-index/exam-format-index.component';
import { ExamFormatNewComponent } from './exam/exam-format-new/exam-format-new.component';
import { ExamSectionIndexComponent } from './exam/exam-section-index/exam-section-index.component';
import { ExamSectionNewComponent } from './exam/exam-section-new/exam-section-new.component';
import { AddProficiencyComponent } from './syllabus/admin-syllabus-subtopic/add-proficiency/add-proficiency.component';
import { AddTemplateToProficiencyComponent } from './syllabus/admin-syllabus-subtopic/add-template-to-proficiency/add-template-to-proficiency.component';
import { TestFunctionComponent } from './test-function/test-function.component';

import { AdminEditBaseRateComponent } from './admin-edit-base-rate/admin-edit-base-rate.component';
import { ModalAddLevelComponent } from './admin-levels/modal-add-level/modal-add-level.component';
import { AdminSubjectNewComponent } from './admin-subjects/admin-subject-new/admin-subject-new.component';
import { UserRoleIndexComponent } from './adminAuth/user-role-index/user-role-index.component';
import { MoveSubtopicComponent } from './syllabus/admin-syllabus-subtopic/move-subtopic/move-subtopic.component';

import { TaskTemplateListComponent } from './admin-syllabus/task-template-list/task-template-list.component';
import { AddPermissionToRoleComponent } from './adminAuth/add-permission-to-role/add-permission-to-role.component';
import { AddUserToRoleComponent } from './adminAuth/add-user-to-role/add-user-to-role.component';
import { NewGuardianComponent } from './adminAuth/new-guardian/new-guardian.component';
import { NewPermissionComponent } from './adminAuth/new-permission/new-permission.component';
import { NewRoleComponent } from './adminAuth/new-role/new-role.component';
import { PermissionIndexComponent } from './adminAuth/permission-index/permission-index.component';
import { UserListByRoleComponent } from './adminAuth/user-list-by-role/user-list-by-role.component';
import { DrillSkillIndexComponent } from './drillSkill/drill-skill-index/drill-skill-index.component';
import { DrillSkillShowComponent } from './drillSkill/drill-skill-show/drill-skill-show.component';
import { DrillSkillSubSkillIndexComponent } from './drillSkill/drill-skill-sub-skill-index/drill-skill-sub-skill-index.component';
import { DrillSubSkillIndexComponent } from './drillSkill/drill-sub-skill-index/drill-sub-skill-index.component';
import { DrillSubSkillShowComponent } from './drillSkill/drill-sub-skill-show/drill-sub-skill-show.component';
import { AddFactToSubTopicComponent } from './facts/add-fact-to-sub-topic/add-fact-to-sub-topic.component';
import { AddHoaxToFactComponent } from './facts/add-hoax-to-fact/add-hoax-to-fact.component';
import { LoadFactComponent } from './facts/load-fact/load-fact.component';
import { TransferToHoaxComponent } from './facts/transfer-to-hoax/transfer-to-hoax.component';
import { GiftCategoryEditComponent } from './gifts/gift-category-edit/gift-category-edit.component';
import { GiftCategoryIndexComponent } from './gifts/gift-category-index/gift-category-index.component';
import { GiftDetailEditComponent } from './gifts/gift-detail-edit/gift-detail-edit.component';
import { GiftDetailIndexComponent } from './gifts/gift-detail-index/gift-detail-index.component';
import { AdminSyllabusShowComponent } from './syllabus/admin-syllabus-show/admin-syllabus-show.component';
import { DuplicateSyllabusComponent } from './syllabus/duplicate-syllabus/duplicate-syllabus.component';
import { UpdateFactTemplateComponent } from './facts/update-fact-template/update-fact-template.component';
import { CurriculumIndexComponent } from './curriculum/curriculum-index/curriculum-index.component';
import { CurriculumShowComponent } from './curriculum/curriculum-show/curriculum-show.component';
import { SubTopicAllIndexComponent } from './SubTopic/sub-topic-all-index/sub-topic-all-index.component';
import { SentMessageListComponent } from './messages/sent-message-list/sent-message-list.component';
import { SentMessageListAllComponent } from './messages/sent-message-list-all/sent-message-list-all.component';
import { SentMessageListByUserComponent } from './messages/sent-message-list-by-user/sent-message-list-by-user.component';
import { RoleGroupIndexComponent } from './adminAuth/role-group-index/role-group-index.component';
import { RoleGroupCreateComponent } from './adminAuth/role-group-create/role-group-create.component';





@NgModule({
  declarations: [
    AdminHomeShowComponent,
    AdminUsersComponent,
    AdminGuardiansComponent,
    AdminSettingsComponent,
    AdminAgentComponent,
    AdminInvoicesComponent,
    AdminDeviceSyncComponent,
    AdminDataComponent,
    AdminAccountsComponent,
    AdminSubjectIndexComponent,
    AdminBillingChartComponent,
    AdminEnrollmentsComponent,
    AdminAwardedComponent,
    AdminStudentsComponent,
    AdminQuizEnvelopsComponent,
    AdminHistoryComponent,
    AdminBadgedComponent,
    AdminSyllabusShowComponent,
    AdminSyllabusIndexComponent,
    AdminSyllabusSubtopicShowComponent,
    AdminSyllabusTopicShowComponent,
    TaskTemplateCreateComponent,
    QuestionTemplateShowComponent,
    QuestionTemplateIndexComponent,
    QuestionTemplateEditComponent,
    AnswerTemplateIndexComponent,
    AnswerTemplateCreateComponent,
    AnswerTemplateShowComponent,
    AnswerTemplateEditComponent,
    AdminShowQuizComponent,
    AdminShowQuestionComponent,
    AdminShowQuestionDetailComponent,
    AdminSyllabusSubtopicEditComponent,
    AdminSyllabusTopicEditComponent,
    AdminConceptIndexComponent,
    AdminConceptShowComponent,
    AdminConceptNewComponent,
    AdminSyllabusSubtopicAddConceptComponent,
    AdminSyllabusSubtopicAddTemplateComponent,
    AdminSyllabusAddSubtopicComponent,
    QuestionTemplateQuestionsComponent,
    ActivityTypeIndexComponent,
    ActivityTypeNewComponent,
    UserActivityIndexComponent,
    UserLastActivityIndexComponent,
    AdminEditBillingRateComponent,
    MoveStudentComponent,
    AddSolutionComponent,
    ManageStudentComponent,
    DeviceSyncDetailComponent,
    AdminSyllabusNewComponent,
    AdminSyllabusAddTopicComponent,
    ProgressEmailListComponent,
    QuestionTemplateRenameComponent,
    AnswerTemplateRenameComponent,
    FactIndexComponent,
    FactShowComponent,
    ReplaceTemplateComponent,
    SearchSubTopicComponent,
    TestImageComponent,
    FactSubTopicIndexComponent,
    IndexCountryComponent,
    NewCountryComponent,
    ShowCountryComponent,
    IndexLevelComponent,
    ShowLevelComponent,
    EditLevelComponent,
    ListLevelTemplateComponent,

    TestFunctionComponent,
    BoldEmitterComponent,
    ExamFormatIndexComponent,
    ExamFormatNewComponent,
    ExamSectionIndexComponent,
    ExamSectionNewComponent,
    FactIndexComponent,
    FactShowComponent,
    FactSubTopicIndexComponent,
    FactEditComponent,
    FactNewComponent,
    AbilityIndexComponent,
    AbilityEditComponent,
    AbilityShowComponent,
    TaskTemplateAbilityComponent,
    TaskDescriptionComponent,
    TaskDescriptionTopologyOneComponent,
    TaskDescriptionTopologyMultipartComponent,
    TaskTemplateLoadComponent,
    TaskPartModalComponent,
    TaskVariantPartModalComponent,
    TaskTemplateCreateVariantComponent,
    AddProficiencyComponent,
    AddTemplateToProficiencyComponent,
    ViewTaskSampleComponent,
    ViewSampleDetailComponent,
    AdminFreeWorksheetComponent,
    NewEducationSystemComponent,
    ListEducationSystemComponent,
    ModalAddLevelComponent,
    AdminSubjectNewComponent,
    MoveSubtopicComponent,
    AdminEditBaseRateComponent,
    GiftDetailIndexComponent,
    GiftDetailEditComponent,
    GiftCategoryIndexComponent,
    GiftCategoryEditComponent,
    DrillSkillIndexComponent,
    DrillSkillShowComponent,
    DrillSkillSubSkillIndexComponent,
    DrillSubSkillIndexComponent,
    DrillSubSkillShowComponent,
    UserRoleIndexComponent,
    PermissionIndexComponent,
    NewRoleComponent,
    AddUserToRoleComponent,
    NewPermissionComponent,
    AddPermissionToRoleComponent,
    UserListByRoleComponent,
    AddFactToSubTopicComponent,
    DuplicateSyllabusComponent,
    NewGuardianComponent,
    TaskTemplateListComponent,
    AddHoaxToFactComponent,
    TransferToHoaxComponent,
    LoadFactComponent,
    UpdateFactTemplateComponent,
    CurriculumIndexComponent,
    CurriculumShowComponent,
    SubTopicAllIndexComponent,
    SentMessageListComponent,
    SentMessageListAllComponent,
    SentMessageListByUserComponent,
    RoleGroupIndexComponent,
    RoleGroupCreateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    DataTablesModule,
    MathModule,
    GuardianModule,
    QuizModule
  ],
  providers:[
    authInterceptorProviders
  ]
})
export class AdminModule { }
